import { createSelector } from 'reselect';

import { AppState } from '../../../store';

export const standPageSelector = (state: AppState) => state.StandPage;

export const standDataSelector = createSelector(standPageSelector, item => {
  return item.data
});
